export const NOTIFICATION_BASE_URL =
  process.env.REACT_APP_NOTIFICATION_BASE_URL;
export const AUTH_BASE_URL = process.env.REACT_APP_AUTH_BASE_URL;
export const CONTRACT_BASE_URL = process.env.REACT_APP_CONTRACT_BASE_URL;
export const PAYMENT_BASE_URL = process.env.REACT_APP_PAYMENT_BASE_URL;
export const PAYMENT_BASE_URL_V2 = process.env.REACT_APP_PAYMENT_BASE_URL_V2;
export const CONTRACT_ACTION_BASES_URL =
  process.env.REACT_APP_CONTRACT_ACTION_BASES_URL;
export const CONTRACT_URL = process.env.REACT_APP_CONTRACT_URL;
export const FINISHED_SETTLEMENTS_URL =
  process.env.REACT_APP_FINISHED_SETTLEMENTS_URL;
export const VOUCHER_URL = process.env.REACT_APP_VOUCHER_URL;
export const CONFIGS_BASE_URL = process.env.REACT_APP_CONFIGS_BASE_URL;
export const REACT_APP_WEBHOOK_URL = process.env.REACT_APP_WEBHOOK_URL;

export const GET_BANKS_INFO = (id) => `/api/users/${id}/banks`;
export const GET_TRANSACTION = "/transactions";
export const GET_BALANCE = (id) => `/balances/${id}`;

export const PROFILE_URL = "api/profiles";
export const LOGIN_URL = "login";
export const REGISTRATION_URL = "/register";
export const PROFILES = "/profiles";
export const CONTRACT_ENDPOINT = "/contracts";
export const GET_CONTRACT_STATS = "api/contracts/statistics";
export const GET_USER_STATS = "api/users/statistics";
export const HYPER_PAY_CALL_BACK_URL =
  process.env.REACT_APP_HYPER_PAY_SHOPPER_URL;
export const ROUTES = {
  HOME: "/",
  STAT_USER_ID: "/stats-user/:id",
  STAT_USER: "/stats-user/",
  LOGIN: "/login",

  CONTRACT: "/contract/",
  CONTRACT_DETAILS: "/contract/:id",
  ONBOARDING: "/onboarding",
  PRIVATE_CONTRACT_DETAILS: "/private-contract-details",
  CONTRACT_NOT_FOUND: "/not-found",
  PROFILE: "/profile",
  CONTRACTS_LIST: "/contracts",
  CONTRACTS_LIST_V2: "/contractsV2",
  USERS: "/users",
  PAYMENT: "/payment",
  DASHBOARD: "/dashboard",
  PAYMENTS: "/payments",
  USERS_MANAGEMENT: "/users-management",
  USER_DETAILS: "/users-management/:id",
  ORGANIZATIONS: "/organizations",
  ORGANIZATIONS_DETAILS: "/organizations/:code",
  SETTINGS: "/settings",
  SETTLEMENTS: "/settlements",
  SETTLEMENT_DETAILS: "/settlements/:id",
  CASHOUTS: "/cashouts",
  MULTI_CASHOUTS: "/multi-cashouts",
  WITHDRAWS: "/withdraws",
  LATEST_UPDATES: "/latest-updates",
  CASHOUT_DETAILS: "/cashouts/:id",
  MULTI_CASHOUT_DETAILS: "/multi-cashouts/:id",
  BALANCE: "/balance",
  WITHDRAW_DETAILS: "/withdraws/:id",
  COMPLETED_TRANSFERS: "/completed-transfers",
  MONEY_TRANSACTIONS: "/money-transactions",
  ALERTS: "/alerts",
  ADVERTISEMENT: "/advertisement",
  CREATE_COMPLEX_CONTRACT: "/create-contract/:complexId?/:milestoneId?",
};
export const PROFILE_PATH_PARAMS = {
  ME: "info",
  ADDRESS: "address",
  PAYMENT_METHOD: "payment-methods",
  PIN_CODE: "pin-code",
  MOBILE_NUMBER: "phone-number",
};
export const LOCALIZE_DATE = "ar-EG";
export enum role {
  admin = "admin",
  user = "user",
}
